import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface DownloadDiagramDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onDownload: (filename: string) => void;
}

const DownloadDiagramDialog: React.FC<DownloadDiagramDialogProps> = ({
  isOpen,
  onClose,
  onDownload,
}) => {
  const [filename, setFilename] = useState("diagram");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (filename.trim()) {
      onDownload(filename.trim());
      onClose();
    }
  };

  const handleClose = () => {
    setFilename("diagram");
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className="bg-surface border-surface-border text-white">
        <DialogHeader>
          <DialogTitle className="text-white">Download Diagram</DialogTitle>
          <DialogDescription className="text-muted">
            Download diagram on your local machine
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="filename" className="text-white">
              Diagram Name
            </Label>
            <Input
              id="filename"
              value={filename}
              onChange={(e) => setFilename(e.target.value)}
              className="bg-surface-active text-white placeholder:text-muted"
              placeholder="Enter diagram name"
              required
            />
          </div>
          <div className="flex justify-end gap-2 mt-4">
            <Button
              type="button"
              variant="outline"
              onClick={handleClose}
              className="bg-surface border border-surface-border hover:bg-surface-hover hover:border-surface-border text-white"
            >
              Cancel
            </Button>
            <Button 
              type="submit" 
              disabled={!filename.trim()}
              className="bg-primary hover:bg-primary-dark text-white"
            >
              Download
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default DownloadDiagramDialog;